<template>
  <div>
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility6"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("App Settings") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility6 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="">
          <b-col
            class="d-flex align-items-center justify-content-between mb-1"
            md="12"
          >
            <h4 class="mr-1">{{ $t("Teacher App") }}</h4>
            <b-form-checkbox v-model="appObj.teacherApp" switch />
          </b-col>
          <b-col
            class="d-flex align-items-center justify-content-between mb-1"
            md="12"
          >
            <h4 class="mr-1">{{ $t("Father App") }}</h4>
            <b-form-checkbox v-model="appObj.fatherApp" switch />
          </b-col>
          <b-col
            class="d-flex align-items-center justify-content-between mb-1"
            md="12"
          >
            <h4 class="mr-1">{{ $t("Mother App") }}</h4>
            <b-form-checkbox v-model="appObj.motherApp" switch />
          </b-col>
          <b-col
            class="d-flex align-items-center justify-content-between mb-1"
            md="12"
          >
            <h4 class="mr-1">{{ $t("Student App") }}</h4>
            <b-form-checkbox v-model="appObj.studentApp" switch />
          </b-col>

          <b-col class="mt-1" md="12">
            <b-button
              variant="success"
              :disabled="saving"
              block
              @click="saveApp()"
            >
              <b-spinner v-if="saving" small type="grow" />
              <span v-else> {{ $t("Save") }} </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
      @hidden="onUserSidebarHidden"
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          {{ $t(sidebarTitle) }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row>
          <b-col cols="12">
            <b-form-group
              class="text-center user-profile-photo-group"
              ref="picture"
              label=" "
              label-for="name-input"
              :invalid-feedback="$t('Picture is required.')"
            >
              <div
                v-if="!profilePicturePreview && logoloading !== true"
                class="user-photo-wrap"
              >
                <b-link @click="$refs.fileProfile.click()">
                  <b-img
                    ref="previewEl"
                    src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
                    style="border-radius: 100px"
                    height="120px"
                    width="120px"
                  />
                </b-link>
              </div>

              <div
                v-else-if="!profilePicturePreview && logoloading === true"
                class="user-photo-wrap"
              >
                <b-spinner
                  variant="primary"
                  type="grow"
                  class="m-2"
                  :label="$t('Spinning')"
                ></b-spinner>
              </div>

              <div v-else class="user-photo-wrap">
                <div class="user-photo-frame">
                  <img
                    class="rcorners2 user-photo-img"
                    :src="profilePicturePreview"
                    referrerpolicy="no-referrer"
                    alt="Profile photo"
                    @click="logoloading !== true && $refs.fileProfile.click()"
                    @error="onProfilePreviewError"
                  />
                  <div
                    v-if="logoloading === true"
                    class="user-photo-upload-overlay"
                  >
                    <b-spinner variant="primary" type="grow" />
                  </div>
                  <b-button
                    v-if="logoloading !== true"
                    class="user-photo-delete-btn"
                    variant="danger"
                    @click.stop="deleteLogo()"
                  >
                    <feather-icon icon="Trash2Icon" size="16" />
                  </b-button>
                </div>
              </div>

              <input
                type="file"
                id="fileProfile"
                hidden
                ref="fileProfile"
                @change="selectlogo()"
                accept="image/*"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col md="12">
            <b-form-group
              :label="$t('Name')"
              :invalid-feedback="$t('Name is required')"
            >
              <b-form-input
                :placeholder="$t('Enter name')"
                name="classField"
                ref="nameUser"
                v-model="userObj.name"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              :label="$t('Username')"
              :invalid-feedback="$t('Username is required')"
              ref="UName"
            >
              <b-form-input
                :placeholder="$t('Enter username')"
                name="classField"
                ref="uName"
                :disabled="userObj.id > 0"
                v-model="userObj.username"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              :label="$t('Password')"
              :invalid-feedback="$t('Password is required')"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  :type="passwordFieldType"
                  :placeholder="$t('Enter password')"
                  name="classField"
                  ref="pass"
                  v-model="userObj.password"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    class="cursor-pointer"
                    :icon="passwordToggleIcon"
                    @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              :label="$t('Select role')"
              :invalid-feedback="$t('Role is required')"
              ref="role"
            >
              <v-select
                ref="role"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                v-model="selectedRole"
                :options="allRoles"
                label="name"
                :placeholder="$t('Select role')"
                @input="setRoleData()"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              class="mr-1 fullWidth"
              @click="Add()"
              :disabled="loading"
              block
            >
              <b-spinner v-if="loading" small type="grow" />
              <span v-else> {{ $t(sidebarButton) }} </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <!-- Bulk User Sidebar -->
    <b-sidebar
      id="sidebar-bulk-user"
      ref="bulkUserSidebar"
      bg-variant="white"
      v-model="visibilityBulkUser"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Bulk User Creation") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibilityBulkUser = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row>
          <b-col md="12" class="mb-2">
            <b-form-group
              :label="$t('Select Department')"
              :invalid-feedback="$t('Department is required.')"
              ref="bulkDepartment"
            >
              <v-select
                ref="bulkDepartment"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                multiple
                :closeOnSelect="false"
                v-model="selectedBulkDepartments"
                :options="departmentOptions"
                :reduce="(val) => val.id"
                label="name"
                :placeholder="$t('Select department')"
                @input="loadBulkStaff()"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" class="mb-2">
            <b-form-group
              :label="$t('Select Staff')"
              :invalid-feedback="$t('At least one staff member is required.')"
              ref="bulkStaff"
            >
              <v-select
                ref="bulkStaff"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                multiple
                :closeOnSelect="false"
                v-model="selectedBulkStaff"
                :options="bulkStaffOptions"
                :reduce="(val) => val.id"
                label="name"
                :placeholder="$t('Search and select staff member')"
                :filterable="true"
                :loading="bulkStaffLoading"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" class="mb-2">
            <b-form-group
              :label="$t('Select Role')"
              :invalid-feedback="$t('Role is required')"
              ref="bulkRole"
            >
              <v-select
                ref="bulkRole"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                v-model="selectedBulkRole"
                :options="allRoles"
                label="name"
                :placeholder="$t('Select role')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" class="mb-2">
            <b-form-group :label="$t('Default Password')">
              <b-form-input
                type="password"
                :placeholder="$t('Enter default password')"
                v-model="bulkUserPassword"
              />
              <small class="text-muted">{{
                $t("This password will be set for all selected staff members")
              }}</small>
            </b-form-group>
          </b-col>

          <b-col md="12" class="mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              class="mr-1 fullWidth"
              @click="saveBulkUsers()"
              :disabled="bulkUserLoading"
              block
            >
              <b-spinner v-if="bulkUserLoading" small type="grow" />
              <span v-if="bulkUserLoading == false">
                {{ $t("Create Users") }}
              </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-modal
      id="modal-roles"
      hide-footer
      hide-header
      centered
      :title="$t('Settings')"
      size="lg"
    >
      <div class="p-1">
        <h1 class="text-center">{{ $t("Add New Role") }}</h1>
        <h5 class="text-center">{{ $t("Set role permissions") }}</h5>

        <b-row class="ml-2 mr-2 mt-1">
          <b-col class="p-0" md="12">
            <b-form-group :label="$t('Role Name')">
              <b-form-input
                ref="name"
                v-model.trim="roleObj.name"
                placeholder="Enter role name"
                @focusout="CheckName()"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="scrollContent">
          <b-row class="m-1 mb-1">
            <b-col class="p-0" md="5">
              <!-- <h5 class="mb-0 d-flex justify-content-end">Select All</h5> -->
            </b-col>
            <b-col class="d-flex align-items-center flex-wrap" md="7">
              <b-form-checkbox
                @change="ToggleAll('view')"
                v-model="all.view"
              /><span class="mr-1">{{ $t("View") }}</span>
              <b-form-checkbox
                @change="ToggleAll('add')"
                v-model="all.add"
              /><span class="mr-1">{{ $t("Add") }}</span>
              <b-form-checkbox
                @change="ToggleAll('edit')"
                v-model="all.edit"
              /><span class="mr-1">{{ $t("Edit") }}</span>
              <b-form-checkbox
                @change="ToggleAll('delete')"
                v-model="all.delete"
              /><span class="mr-1">{{ $t("Delete") }}</span>
            </b-col>
          </b-row>

          <b-row
            class="m-1 mb-1"
            v-for="item in myObj"
            :key="item.id"
            v-if="item.children.length > 0"
          >
            <b-col class="p-0" md="12">
              <h4 class="font-weight-bolder mb-0">{{ $t(item.name) }}</h4>
            </b-col>
            <b-col v-for="child in item.children" :key="child.title" md="12">
              <b-row
                style="border-bottom: 1px solid lightgray"
                class="pt-1 pb-1"
              >
                <b-col class="p-0" md="5">
                  <h5 class="mb-0">{{ $t(child.title) }}</h5>
                </b-col>
                <b-col class="d-flex align-items-center flex-wrap" md="7">
                  <b-form-checkbox v-model="child.view"
                    ><span class="mr-1">{{ $t("View") }}</span>
                  </b-form-checkbox>

                  <template v-if="child.title !== 'Notifications'">
                    <b-form-checkbox v-model="child.add">
                      <span class="mr-1">{{ $t("Add") }}</span>
                    </b-form-checkbox>

                    <b-form-checkbox v-model="child.edit"
                      ><span class="mr-1">{{ $t("Edit") }}</span>
                    </b-form-checkbox>

                    <b-form-checkbox v-model="child.delete"
                      ><span class="mr-1">{{ $t("Delete") }}</span>
                    </b-form-checkbox>
                  </template>

                  <template v-if="child.title == 'Students'">
                    <b-form-checkbox v-model="child.hideFee"
                      ><span class="mr-1">{{ $t("Hide Fee") }}</span>
                    </b-form-checkbox>
                    <b-form-checkbox v-model="child.editCampus"
                      ><span class="mr-1">{{ $t("Edit Campus") }}</span>
                    </b-form-checkbox>

                    <!-- <template v-if="reportDomain == 'myskoolhpgs'">
                      <b-form-checkbox v-model="child.confirmAdmission"
                        ><span class="mr-1">Confirm Admission</span>
                      </b-form-checkbox>
                      <b-form-checkbox v-model="child.leftStudent"
                        ><span class="mr-1">Left Student</span>
                      </b-form-checkbox>
                    </template> -->
                  </template>

                  <template
                    v-if="
                      reportDomain == 'myskoolhpgs' &&
                      child.route == 'manage-studentgrid'
                    "
                  >
                    <b-form-checkbox-group
                      id="checkbox-group-3"
                      v-model="child.editAllows"
                      :options="editOptions"
                    ></b-form-checkbox-group>
                  </template>

                  <template
                    v-if="
                      reportDomain == 'myskoolhpgs' &&
                      child.route == 'manage-classes'
                    "
                  >
                    <b-form-checkbox v-model="child.assignSections"
                      ><span class="mr-1">{{ $t("Assign Sections") }}</span>
                    </b-form-checkbox>
                  </template>

                  <template
                    v-if="
                      reportDomain == 'myskoolhpgs' &&
                      ['Staff Applicants', 'Applicants'].includes(child.title)
                    "
                  >
                    <b-form-checkbox v-model="child.interviewInfo"
                      ><span class="mr-1">{{
                        $t("Interview Information")
                      }}</span>
                    </b-form-checkbox>
                    <b-form-checkbox v-model="child.approve"
                      ><span class="mr-1">{{ $t("Approve Applicant") }}</span>
                    </b-form-checkbox>
                  </template>

                  <template v-if="child.route == 'manage-staffgrid'">
                    <b-form-checkbox v-model="child.hidePayroll"
                      ><span class="mr-1">{{ $t("Hide Payroll") }}</span>
                    </b-form-checkbox>
                    <b-form-checkbox v-model="child.bulkIncrement"
                      ><span class="mr-1">{{ $t("Bulk Increment") }}</span>
                    </b-form-checkbox>
                    <b-form-checkbox v-model="child.hideDocuments"
                      ><span class="mr-1">{{ $t("Hide Documents") }}</span>
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-if="['myskoolhpgs'].includes(reportDomain)"
                      v-model="child.singlePage"
                      ><span class="mr-1">{{ $t("Single Page") }}</span>
                    </b-form-checkbox>
                  </template>

                  <!-- <b-form-checkbox
                    v-if="child.route == 'requisition'"
                    v-model="child.approve"
                    ><span class="mr-1">Approve</span>
                  </b-form-checkbox> -->
                  <template v-if="child.route == 'requisition'">
                    <b-form-checkbox-group
                      id="checkbox-group-2"
                      v-model="child.editAllows"
                      :options="requisitionOptions"
                    ></b-form-checkbox-group>
                  </template>

                  <template v-if="child.route == 'manage-challan'">
                    <b-form-checkbox v-model="child.receiveFee"
                      ><span class="mr-1">{{ $t("Receive Fee") }}</span>
                    </b-form-checkbox>
                    <b-form-checkbox v-model="child.disableDate"
                      ><span class="mr-1">{{ $t("Disable Date") }}</span>
                    </b-form-checkbox>
                    <b-form-checkbox v-model="child.hideFee"
                      ><span class="mr-1">{{ $t("Hide History") }}</span>
                    </b-form-checkbox>
                    <b-form-checkbox v-model="child.disableReceiving"
                      ><span class="mr-1">{{ $t("Disable Receiving") }}</span>
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-if="editRcvDate && editRcvDate.valueBool"
                      v-model="child.editDate"
                      ><span class="mr-1">{{ $t("Edit Receiving Date") }}</span>
                    </b-form-checkbox>
                  </template>

                  <template v-if="child.title == 'Notifications'">
                    <b-form-checkbox-group
                      id="checkbox-group-notification"
                      v-model="child.notificationTypes"
                      :options="notificationOptions"
                    ></b-form-checkbox-group>
                  </template>

                  <template
                    v-if="
                      roleCoaAccessEnabled &&
                      child.route == 'accounts' &&
                      (child.view || child.add || child.edit)
                    "
                  >
                    <div class="w-100 mt-50">
                      <label class="d-block mb-25 font-weight-bold">{{
                        $t("Chart of Accounts Access")
                      }}</label>
                      <v-select
                        multiple
                        :closeOnSelect="false"
                        v-model="child.coaAccountIDs"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="coaRoleOptions"
                        :reduce="(val) => val.id"
                        label="title"
                        :clearable="false"
                        :placeholder="$t('All Accounts')"
                        @input="setRoleCoaAccounts(child)"
                      />
                      <small class="text-muted">{{
                        $t(
                          "Leave as All Accounts or pick specific heads."
                        )
                      }}</small>
                    </div>
                  </template>

                  <template v-if="child.route == 'journal'">
                    <b-form-checkbox v-model="child.disableDate"
                      ><span class="mr-1">{{ $t("Disable Date") }}</span>
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-if="reviewObj && reviewObj.valueBool"
                      v-model="child.review"
                      ><span class="mr-1">{{ $t("Review") }}</span>
                    </b-form-checkbox>
                  </template>

                  <template v-if="child.route == 'report'">
                    <b-form-checkbox-group
                      id="checkbox-group-1"
                      v-model="child.reportTypes"
                      :options="reportOptions"
                    ></b-form-checkbox-group>
                  </template>

                  <template
                    v-if="
                      ['myskoolhpgs'].includes(reportDomain) &&
                      child.route == 'dashboard-ecommerce'
                    "
                  >
                    <b-form-checkbox-group
                      id="checkbox-group-4"
                      v-model="child.reportTypes"
                      :options="dashOptions"
                    ></b-form-checkbox-group>
                  </template>

                  <template
                    v-else-if="child.route == 'dashboard-ecommerce'"
                  >
                    <b-form-checkbox-group
                      id="checkbox-group-result-comparison"
                      v-model="child.reportTypes"
                      :options="resultComparisonRightOptions"
                    ></b-form-checkbox-group>
                  </template>

                  <b-form-checkbox
                    v-if="importList.includes(child.route)"
                    v-model="child.disableImport"
                    ><span class="mr-1">{{ $t("Hide Import") }}</span>
                  </b-form-checkbox>

                  <b-form-checkbox
                    v-if="exportList.includes(child.route)"
                    v-model="child.disableExport"
                    ><span class="mr-1">{{ $t("Hide Export") }}</span>
                  </b-form-checkbox>

                  <b-form-checkbox
                    v-if="
                      reportDomain === 'myskoolcrestviewacademy' &&
                      ['manage-inquiry', 'inquiry'].includes(child.route)
                    "
                    v-model="child.optional"
                    ><span class="mr-1">{{ $t("Optional") }}</span>
                  </b-form-checkbox>

                  <b-form-checkbox
                    v-if="child.title == 'Campuses'"
                    v-model="child.permission"
                    value="switch-campus"
                    unchecked-value=""
                    ><span class="mr-1">{{ $t("Switch Campus") }}</span>
                  </b-form-checkbox>

                  <!-- <b-form-checkbox
                    v-for="data in child.permission"
                    :key="data"
                    v-model="data.value"
                    class="mr-1"
                    >{{ data.text }}
                  </b-form-checkbox> -->
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>

        <b-row class="mt-1">
          <b-col md="12" class="text-right">
            <b-button variant="success" @click="save()" :disabled="request">
              <b-spinner v-if="request" small type="grow" />
              <span v-else> {{ $t("Save") }} </span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal
      id="modal-classes"
      hide-footer
      centered
      :title="$t('Manage Classes')"
      size="lg"
    >
      <b-row class="mb-1">
        <b-col md="12">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="44"
                :src="getAvatarPreviewUrl(currentUser.avatar)"
                variant="light-primary"
                referrerpolicy="no-referrer"
              />
            </template>

            <b-link class="font-weight-bold d-block text-nowrap">
              {{ currentUser.name }}
            </b-link>
            <small class="text-muted">{{ currentUser.username }}</small>
          </b-media>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4">
          <b-form-group
            :label="$t('Class')"
            :invalid-feedback="$t('Class is required')"
            ref="tcID"
          >
            <v-select
              v-model="teachingClassObj.clsID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="classesOptions"
              :clearable="false"
              :reduce="(val) => val.id"
              label="name"
              input-id="id"
              ref="tcID"
              @input="FillSections()"
              @search:blur="CheckTcID()"
              :placeholder="$t('Select class')"
            />
          </b-form-group>
        </b-col>
        <b-col md="8">
          <b-form-group
            :label="$t('Section')"
            :invalid-feedback="$t('Section is required')"
            ref="tSection"
          >
            <v-select
              ref="tSection"
              multiple
              :closeOnSelect="false"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="selectedSections"
              :options="admittedSections"
              :reduce="(val) => val.id"
              label="section"
              :clearable="false"
              @input="setSections()"
              @search:blur="CheckTSection()"
              :placeholder="$t('Select section')"
            />
          </b-form-group>
        </b-col>
        <b-col md="10">
          <b-form-group
            :label="$t('Subject')"
            :invalid-feedback="$t('Subject is required.')"
            ref="tSubjects"
          >
            <v-select
              ref="tSubjects"
              multiple
              :closeOnSelect="false"
              v-model="selectedSubs"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="subjects"
              :reduce="(val) => val.id"
              label="subject"
              :clearable="false"
              @input="setSubjects()"
              @search:blur="CheckTSubject()"
              :placeholder="$t('Select assigned subject.')"
            />
          </b-form-group>
        </b-col>

        <b-col md="2">
          <b-form-group label="" class="mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="btn-icon"
              variant="success"
              @click="assign()"
              :disabled="assigning"
              block
            >
              <b-spinner v-if="assigning" small />
              <span v-else>{{ $t("Save") }}</span>
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        class="mt-1"
        sticky-header
        :items="gridData"
        :fields="fields2"
        responsive
        hover
      >
        <template #head()="scope">
          <div>
            {{ $t(scope.label) }}
          </div>
        </template>
        <template #cell(subjects)="data">
          <b-badge
            variant="light-primary"
            v-for="sub in data.item.subjects"
            :key="data.sub"
            style="margin: 2px"
          >
            <span>{{ sub.subject }}</span>
            <feather-icon
              icon="XIcon"
              class="ml-50"
              @click="removeSingle(data.item, sub)"
            />
          </b-badge>
        </template>
        <template #cell(actions)="data">
          <div class="">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-danger"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click="DeleteSub(data.item)"
              v-b-tooltip.hover.left
              :title="$t('Delete')"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </template>
      </b-table>
    </b-modal>

    <div v-if="dataLoading" class="d-flex justify-content-center mb-3 mt-3">
      <b-spinner
        style="width: 3rem; height: 3rem"
        type="grow"
        variant="primary"
        :label="$t('Spinning')"
      ></b-spinner>
    </div>
    <b-row class="match-height" v-else>
      <b-col md="3" v-for="role in allRoles" :key="role.id">
        <b-card>
          <div class="d-flex justify-content-between">
            <div class="truncate">
              <h4 class="mb-25 font-weight-bolder">{{ role.name }}</h4>
              <b-spinner
                v-if="editLoading && checkId == role.id"
                small
                variant="primary"
              />
              <span
                v-else-if="rights.edit"
                class="cursor-pointer text-primary"
                @click="openEdit(role)"
                >{{ $t("Edit Role") }}</span
              >
            </div>
            <b-avatar class="mb-1" variant="light-primary" size="45" />
          </div>
        </b-card>
      </b-col>
      <b-col md="3" v-if="rights.add">
        <b-card>
          <div class="d-flex justify-content-between">
            <b-avatar class="mb-1" variant="light-primary" size="45" />
            <div class="text-right">
              <b-button
                variant="primary"
                @click="openModal()"
                :disabled="request"
              >
                <b-spinner v-if="request" small />
                <span class="text-nowrap" v-else>{{ $t("Add Role") }} </span>
              </b-button>
              <p class="mt-1 mb-0">{{ $t("Add role if it doesn't exist") }}</p>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <user-list-add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      :role-options="roleOptions"
      :plan-options="planOptions"
      @refetch-data="refetchData"
    />

    <!-- Filters -->
    <!-- <users-list-filters
      :role-filter.sync="roleFilter"
      :plan-filter.sync="planFilter"
      :status-filter.sync="statusFilter"
      :role-options="roleOptions"
      :plan-options="planOptions"
      :status-options="statusOptions"
    /> -->

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Search -->
          <b-col cols="12" md="12">
            <div class="d-flex align-items-center justify-content-start">
              <b-button
                v-if="rights.add"
                variant="primary"
                class="mr-1"
                @click="AddOpen()"
              >
                <span class="text-nowrap">{{ $t("Add User") }}</span>
              </b-button>
              <b-button
                v-if="rights.add && reportDomain === 'myskooliuss'"
                variant="success"
                class="mr-1"
                @click="openBulkUser()"
              >
                <span class="text-nowrap">{{ $t("Bulk User") }}</span>
              </b-button>
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block"
                :placeholder="$t('Search') + '...'"
              />
              <b-button
                v-if="rights.edit"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                v-b-tooltip.hover.top
                :title="$t('App Settings')"
                class="btn-icon ml-1"
                @click="visibility6 = true"
              >
                <feather-icon icon="SettingsIcon" class="" />
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="filteredUser"
        responsive
        :fields="fields"
        :busy="userLoading"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        :empty-text="$t('No matching records found')"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: User -->
        <template #table-busy>
          <div class="d-flex justify-content-center mb-3 mt-3">
            <b-spinner
              style="width: 3rem; height: 3rem"
              type="grow"
              variant="primary"
              :label="$t('Spinning')"
            ></b-spinner>
          </div>
        </template>
        <template #head()="scope">
          <div>
            {{ $t(scope.label) }}
          </div>
        </template>

        <template #cell(user)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="getAvatarPreviewUrl(data.item.avatar)"
                variant="light-primary"
                referrerpolicy="no-referrer"
              />
            </template>
            <!-- <b-link
              :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
              class="font-weight-bold d-block text-nowrap"
            >
            {{ data.item.name }}
          </b-link> -->
            <b-link class="font-weight-bold d-block text-nowrap">
              {{ data.item.name }}
            </b-link>
            <small class="text-muted">{{ data.item.username }}</small>
          </b-media>
        </template>

        <!-- Column: Role -->
        <template #cell(role)="data">
          <div class="text-nowrap">
            <feather-icon
              :icon="resolveUserRoleIcon(data.item.role)"
              size="18"
              class="mr-50"
              :class="`text-${resolveUserRoleVariant(data.item.role)}`"
            />
            <span class="align-text-top text-capitalize">{{
              data.item.role
            }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(data.item.status)}`"
            class="text-capitalize"
          >
            {{ data.item.status }}
          </b-badge>
        </template>
        <template #cell(meta_role)="data">
          <b-badge pill variant="light-primary" class="text-capitalize">
            {{ data.item.meta_role }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-button
            v-if="rights.edit"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            v-b-tooltip.hover.left
            :title="$t('Edit')"
            class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
            @click="Edit(data.item)"
          >
            <feather-icon icon="EditIcon" class="" />
          </b-button>

          <!-- <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            v-b-tooltip.hover.left
           :title="$t('Manage Classes')"
            class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
            @click="openClasses(data.item)"
          >
            <feather-icon icon="BookIcon" class="" />
          </b-button> -->

          <b-button
            v-if="rights.delete"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-danger"
            v-b-tooltip.hover.right
            :title="$t('Delete')"
            class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
            @click="Delete(data.item.id)"
          >
            <feather-icon icon="Trash2Icon" />
          </b-button>
          <!-- <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
            >
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Details</span>
            </b-dropdown-item>

            <b-dropdown-item
              :to="{ name: 'apps-users-edit', params: { id: data.item.id } }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item>
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown> -->
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >{{ $t("Showing") }} {{ filteredUser.length }} {{ $t("of") }}
              {{ allUsers.length }} {{ $t("entries") }}</span
            >
            <!-- <span class="text-muted"
              >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
              {{ dataMeta.of }} entries</span
            > -->
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BButton,
  BTable,
  BMedia,
  BMediaAside,
  BImg,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BModal,
  BSidebar,
  BFormCheckbox,
  BFormCheckboxGroup,
  BSpinner,
  BForm,
  BInputGroupAppend,
  BInputGroup,
  VBTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import UsersListFilters from "./UsersListFilters.vue";
import useUsersList from "./useUsersList";
import userStoreModule from "../userStoreModule";
import UserListAddNew from "./UserListAddNew.vue";
import { mapActions, mapGetters } from "vuex";
import Ripple from "vue-ripple-directive";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import {
  getUploadPath,
  uploadToMySkool,
  getMediaPreviewUrl,
  handleDrivePreviewError,
} from "@/utils/gdriveUpload";
import {
  ROLE_COA_ACCESS_SETTING_KEY,
  isRoleCoaAccessEnabled,
  normalizeRoleCoaSelection,
  commitRoleCoaAccessEnabled,
  pickRoleCoaAccessSetting,
} from "@/utils/roleCoaAccess";

export default {
  components: {
    // VBTooltip,
    UsersListFilters,
    UserListAddNew,
    BFormCheckbox,
    BFormCheckboxGroup,
    BModal,
    BForm,
    BFormGroup,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMediaAside,
    BImg,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BSidebar,
    BDropdownItem,
    BPagination,
    BSpinner,
    BInputGroupAppend,
    BInputGroup,
    vSelect,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  computed: {
    roleCoaAccessEnabled() {
      return isRoleCoaAccessEnabled(this.roleCoaAccessSetting);
    },
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    filteredUser() {
      return this.allUsers.filter((pro) => {
        return (
          pro.username.toLowerCase().match(this.searchQuery.toLowerCase()) ||
          (pro.name &&
            pro.name.toLowerCase().match(this.searchQuery.toLowerCase()))
        );
      });
    },
    profilePicturePreview() {
      if (!this.plus) return "";
      if (String(this.plus).startsWith("blob:")) return this.plus;
      return getMediaPreviewUrl(this.plus, "Image");
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "app-user";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const isAddNewUserSidebarActive = ref(false);

    const roleOptions = [
      { label: "Admin", value: "admin" },
      { label: "Author", value: "author" },
      { label: "Editor", value: "editor" },
      { label: "Maintainer", value: "maintainer" },
      { label: "Subscriber", value: "subscriber" },
    ];

    const planOptions = [
      { label: "Basic", value: "basic" },
      { label: "Company", value: "company" },
      { label: "Enterprise", value: "enterprise" },
      { label: "Team", value: "team" },
    ];

    const statusOptions = [
      { label: "Pending", value: "pending" },
      { label: "Active", value: "active" },
      { label: "Inactive", value: "inactive" },
    ];

    const {
      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      // searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useUsersList();

    return {
      // Sidebar
      isAddNewUserSidebarActive,

      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      // searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      roleOptions,
      planOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    };
  },
  data() {
    return {
      searchQuery: "",
      sidebarTitle: "Add User",
      sidebarButton: "Save",
      all: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      fileProfile: "",
      logoloading: false,
      plus: "",
      options: [
        { text: "View", value: "view" },
        { text: "Add", value: "add" },
        { text: "Edit", value: "edit" },
        { text: "Delete", value: "delete" },
      ],
      myObj: [],
      allRoles: [],
      allUsers: [],
      fields: [
        { label: "user", key: "user" },
        { label: "username", key: "username" },
        { label: "role", key: "meta_role" },
        { key: "actions", label: "actions" },
      ],
      roleObj: {
        id: 0,
        campusID: 0,
        name: "",
        forms: "",
      },
      userObj: {
        id: 0,
        username: "",
        password: "",
        userRole: 0,
        name: "",
        avatar: "",
        forms: "",
        meta_role: "",
      },
      selectedRole: null,
      request: false,
      loading: false,
      userLoading: false,
      visibility: false,
      dataLoading: false,
      editLoading: false,
      checkId: 0,
      rights: {},
      permList: [
        {
          title: "Students",
          data: [
            { text: "Hide Export", value: false },
            { text: "Hide Contacts", value: false },
          ],
        },
        {
          title: "Staff",
          data: [
            { text: "Hide Export", value: false },
            { text: "Hide Contacts", value: false },
          ],
        },
      ],
      classes: [],
      classesOptions: [],
      admittedSections: [],
      subjects: [],
      currentUser: {},
      gridData: [],
      fields2: [
        { label: "Class", key: "cls" },
        { label: "section", key: "sec" },
        { label: "subject", key: "subjects" },
        "actions",
      ],
      assigning: false,
      teachingClassObj: {
        userID: 0,
        clsID: 0,
        sections: [],
        subjects: [],
        campusID: this.$store.state.userData.cId,
      },
      selectedSubs: [],
      selectedSections: [],
      appObj: {},
      visibility6: false,
      saving: false,
      visibilityBulkUser: false,
      departmentOptions: [],
      bulkStaffOptions: [],
      selectedBulkDepartments: [],
      selectedBulkStaff: [],
      selectedBulkRole: null,
      bulkUserPassword: "",
      bulkStaffLoading: false,
      bulkUserLoading: false,
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      importList: [
        "manage-studentgrid",
        "student-coachinggrid",
        "manage-staffgrid",
      ],

      exportList: [
        "manage-inquiry",
        "inquiry",
        "manage-studentgrid",
        "student-coachinggrid",
        "manage-staffgrid",
        // "manage-datesheet",
        // "manage-marks"
      ],
      reportOptions: [
        { text: "Collection Report", value: "dcr" },
        { text: "Outstanding Report", value: "defaulters" },
        { text: "Students", value: "Students" },
        { text: "Staff", value: "Staff" },
        { text: "Attendance", value: "Attendance" },
        { text: "Accounts", value: "Accounts" },
        { text: "Advance Accounts", value: "Advance Accounts" },
        { text: "Certificates", value: "Certificates" },
      ],
      editOptions: [
        { text: "Assign GR", value: { name: "Assign GR", field: "grNo" } },
        {
          text: "Update Section",
          value: { name: "Update Section", field: "section" },
        },
      ],
      requisitionOptions: [
        { text: "Under Review", value: "under review" },
        { text: "Review", value: "reviewed" },
        { text: "Approved", value: "approved" },
        { text: "Quotation", value: "quotation" },
      ],
      editRcvDate: null,
      reviewObj: null,
      roleCoaAccessSetting: null,
      coaRoleOptions: [{ id: 0, title: "All Accounts" }],
      coaRoleOptionsLoading: false,
      notificationOptions: [
        { text: "Students", value: "students" },
        { text: "Staff", value: "staff" },
        { text: "Chat", value: "chat" },
        { text: "Inventory", value: "inventory" },
      ],
      dashOptions: [
        { text: "Statistics", value: "statistics" },
        { text: "Dues", value: "dues" },
        { text: "Student Statistics", value: "student-statistics" },
        { text: "Attendance", value: "attendance" },
        { text: "Homework", value: "homework" },
        { text: "Collection", value: "collection" },
        { text: "Result Comparison", value: "result-comparison" },
        { text: "Hold Fees Stats", value: "hold-fees-stats" },
        {
          text: "Staff by Designation",
          value: "staff-designation-stats",
        },
      ],
      resultComparisonRightOptions: [
        { text: "Collection", value: "collection" },
        { text: "Result Comparison", value: "result-comparison" },
        { text: "Hold Fees Stats", value: "hold-fees-stats" },
      ],
    };
  },
  created() {
    if (!this.$store.state.rights[this.$route.name]) {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
      // console.log(this.rights);
      this.LoadData();
      this.LoadUsers();
      // this.LoadInfo();
      this.LoadAppSettings();
      this.LoadSettingsAll();
      this.LoadDepartments();

      if (this.reportDomain == "myskoolszablc") {
        this.reportOptions = this.reportOptions.filter((el) =>
          [
            "dcr",
            "defaulters",
            "Students",
            "Attendance",
            "Certificates",
          ].includes(el.value)
        );
      }
    }
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    async LoadSettingsAll() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettingsAll?db=" +
          this.$store.state.userData.db,
        body: [
          "edit_rcv_date",
          "journal_entry_review",
          ROLE_COA_ACCESS_SETTING_KEY,
        ],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      this.editRcvDate = res.find((el) => el.key == "edit_rcv_date");
      this.reviewObj = res.find((el) => el.key == "journal_entry_review");
      this.roleCoaAccessSetting = pickRoleCoaAccessSetting(
        res,
        this.$store.state.userData.cId
      );
      commitRoleCoaAccessEnabled(this.$store, this.roleCoaAccessSetting);
    },

    // ====== Bulk User Methods =======
    async LoadDepartments() {
      try {
        var obj = {
          url:
            this.$store.state.domain +
            "StaffDepartments?db=" +
            this.$store.state.userData.db +
            "&cId=" +
            this.$store.state.userData.cId,
          token: this.$store.state.userData.token,
        };
        const response = await this.get(obj);
        this.departmentOptions = Array.isArray(response)
          ? response
          : response?.data || [];
      } catch (error) {
        console.error("Error loading departments:", error);
        this.departmentOptions = [];
      }
    },
    async loadBulkStaff() {
      if (
        !this.selectedBulkDepartments ||
        this.selectedBulkDepartments.length === 0
      ) {
        this.bulkStaffOptions = [];
        this.selectedBulkStaff = [];
        return;
      }

      this.bulkStaffLoading = true;
      try {
        // Load staff for all selected departments
        const allStaff = [];
        for (const deptId of this.selectedBulkDepartments) {
          const obj = {
            url:
              this.$store.state.domain +
              "staff/LoadDataPagination?db=" +
              this.$store.state.userData.db +
              "&cId=" +
              this.$store.state.userData.cId +
              "&dptID=" +
              deptId +
              "&status=present&page=1&pageSize=1000&appointedFrom=&appointedTo=&leavingFrom=&leavingTo=&designation=&sortBy=name&sortOrder=asc",
            token: this.$store.state.userData.token,
            dashboard: true,
          };
          const response = await this.get(obj);

          // Handle response structure: response.data or direct array
          let staffData = [];
          if (Array.isArray(response)) {
            staffData = response;
          } else if (
            response &&
            response.data &&
            Array.isArray(response.data)
          ) {
            staffData = response.data;
          }

          // Add staff to array if not already present (avoid duplicates)
          staffData.forEach((staff) => {
            if (!allStaff.find((s) => s.id === staff.id)) {
              const staffName =
                staff.name ||
                `${staff.father_name || ""} ${staff.name || ""}`.trim() ||
                `Staff ${staff.id}`;
              allStaff.push({
                id: staff.id,
                name: staffName,
              });
            }
          });
        }
        this.bulkStaffOptions = allStaff.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
      } catch (error) {
        console.error("Error loading staff:", error);
        this.bulkStaffOptions = [];
        this.$bvToast.toast("Error loading staff. Please try again.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.bulkStaffLoading = false;
      }
    },
    openBulkUser() {
      this.visibilityBulkUser = true;
      this.selectedBulkDepartments = [];
      this.selectedBulkStaff = [];
      this.selectedBulkRole = null;
      this.bulkUserPassword = "";
      this.bulkStaffOptions = [];
    },
    async saveBulkUsers() {
      // Validation
      if (
        !this.selectedBulkDepartments ||
        this.selectedBulkDepartments.length === 0
      ) {
        return this.$bvToast.toast("Please select at least one department.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
      if (!this.selectedBulkStaff || this.selectedBulkStaff.length === 0) {
        return this.$bvToast.toast("Please select at least one staff member.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
      if (!this.selectedBulkRole) {
        return this.$bvToast.toast("Please select a role.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
      if (!this.bulkUserPassword || this.bulkUserPassword.trim() === "") {
        return this.$bvToast.toast("Please enter a default password.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }

      this.bulkUserLoading = true;
      try {
        // Prepare request body with staff IDs (tIDs) and password
        const requestBody = {
          tIDs: this.selectedBulkStaff,
          password: this.bulkUserPassword,
        };

        // Call bulk create API
        const status = await this.post({
          url:
            this.$store.state.domain +
            "Users/BulkCreateUsers?db=" +
            this.$store.state.userData.db +
            "&campusID=" +
            this.$store.state.userData.cId +
            "&userRole=" +
            this.selectedBulkRole.id +
            "&userID=" +
            this.$store.state.userData.userID,
          body: requestBody,
          message: `${this.selectedBulkStaff.length} ${
            this.selectedBulkStaff.length === 1 ? "user" : "users"
          } created successfully.`,
          context: this,
          token: this.$store.state.userData.token,
        });

        if (status) {
          this.LoadUsers();
          this.visibilityBulkUser = false;
          // Reset form
          this.selectedBulkDepartments = [];
          this.selectedBulkStaff = [];
          this.selectedBulkRole = null;
          this.bulkUserPassword = "";
          this.bulkStaffOptions = [];
        }
      } catch (error) {
        console.error("Error creating bulk users:", error);
        this.$bvToast.toast("Error creating users. Please try again.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.bulkUserLoading = false;
      }
    },

    // ===== app settings ========

    async LoadAppSettings() {
      var obj = {
        url:
          this.$store.state.domain +
          "AppSettings?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      this.appObj = res.find(
        (el) => el.campusID == this.$store.state.userData.cId
      );
      if (!this.appObj) {
        this.appObj = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          teacherApp: false,
          fatherApp: false,
          motherApp: false,
          studentApp: false,
        };
      }
      // console.log(this.appObj);
    },
    async saveApp() {
      this.saving = true;
      if (this.appObj.id == 0) {
        let status = await this.post({
          url:
            this.$store.state.domain +
            "AppSettings?db=" +
            this.$store.state.userData.db,
          body: this.appObj,
          message: this.$t("Settings saved successfully!"),
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          this.LoadAppSettings();
          this.visibility6 = false;
        }
      } else {
        let status = await this.put({
          url:
            this.$store.state.domain +
            "AppSettings/" +
            this.appObj.id +
            "?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: this.appObj,
          message: this.$t("Settings saved successfully!"),
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          this.LoadAppSettings();
          this.visibility6 = false;
        }
      }
      this.saving = false;
    },

    // ====== assign classes =======

    async LoadInfo() {
      var obj = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&dID=0",
        token: this.$store.state.userData.token,
      };
      this.classes = await this.get(obj);
      this.classes.forEach((el) => {
        this.classesOptions.push(el.cls);
      });

      var obj2 = {
        url:
          this.$store.state.domain +
          "Subjects?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.subjects = await this.get(obj2);
      if (this.subjects.length > 0) {
        this.subjects.unshift({ subject: "All Subjects", id: 0 });
      }
    },
    openClasses(item) {
      this.currentUser = item;
      this.$bvModal.show("modal-classes");

      // this.loadManageData();
    },
    async loadManageData() {
      var obj = {
        url:
          this.$store.state.domain +
          "TeacherClasses/LoadDataWebNew?db=" +
          this.$store.state.userData.db +
          "&tID=" +
          this.currentUser.id,
        token: this.$store.state.userData.token,
      };
      this.gridData = await this.get(obj);
    },
    FillSections(text) {
      let obj = this.classes.find(
        (el) => el.cls.id == this.teachingClassObj.clsID
      );
      if (obj.sections.length > 0) {
        this.admittedSections = [...obj.sections];
        this.admittedSections.unshift({ section: "All Sections", id: 0 });
      } else {
        this.admittedSections = [];
      }

      if (text != "filled") this.selectedSections = [];
      // console.log("sec", this.admittedSections);
    },
    setSections() {
      if (this.selectedSections.at(-1) == 0) {
        this.selectedSections = [0];
      } else {
        this.selectedSections = this.selectedSections.filter((el) => el != 0);
      }
      // console.log(this.selectedSections);
    },
    setSubjects() {
      if (this.selectedSubs.at(-1) == 0) {
        this.selectedSubs = [0];
      } else {
        this.selectedSubs = this.selectedSubs.filter((el) => el != 0);
      }
      // console.log(this.selectedSubs);
    },
    CheckTcID() {
      var elem = this.$refs["tcID"];
      if (this.teachingClassObj.clsID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckTSection() {
      var elem = this.$refs["tSection"];
      if (this.selectedSections.length === 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckTSubject() {
      var elem = this.$refs["tSubjects"];
      if (this.selectedSubs.length === 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async assign() {
      this.teachingClassObj.userID = parseInt(this.currentUser.id);
      // console.log(this.teachingClassObj);

      this.CheckTcID();
      this.CheckTSubject();
      this.CheckTSection();
      if (
        this.CheckTcID() == false ||
        this.CheckTSubject() == false ||
        this.CheckTSection() == false
      ) {
        return this.$bvToast.toast("Please enter all the required fields.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-right",
        });
      } else {
        this.assigning = true;

        if (this.selectedSections[0] == 0) {
          let secArr = this.classes.find(
            (el) => el.cls.id === this.teachingClassObj.clsID
          ).sections;
          let secs = secArr.reduce((acc, el) => {
            acc.push(el.id);
            return acc;
          }, []);
          this.teachingClassObj.sections = secs;
        } else {
          this.teachingClassObj.sections = this.selectedSections;
        }
        // console.log(this.teachingClassObj.sections);

        if (this.selectedSubs[0] == 0) {
          let subs = this.subjects.reduce((acc, el) => {
            if (el.id != 0) acc.push(el.id);
            return acc;
          }, []);
          this.teachingClassObj.subjects = subs;
        } else {
          this.teachingClassObj.subjects = this.selectedSubs;
        }
        // console.log(this.teachingClassObj.subjects);

        var status = await this.post({
          url:
            this.$store.state.domain +
            "TeacherClasses/SaveData?db=" +
            this.$store.state.userData.db,
          body: this.teachingClassObj,
          message: "Classes assigned successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          this.loadManageData();
          this.teachingClassObj = {
            userID: this.currentUser.id,
            clsID: 0,
            sections: [],
            subjects: [],
            campusID: this.$store.state.userData.cId,
          };
          this.selectedSections = [];
          this.selectedSubs = [];
        }
        this.assigning = false;
      }
    },
    async removeSingle(row, sub) {
      // console.log(row, sub);
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "TeacherClasses/" +
            sub.id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          message: "subject removed successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.loadManageData();
      }
    },
    async DeleteSub(item) {
      // console.log(item);
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "Staff/DeleteSubjects?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&clsID=" +
            item.clsID +
            "&secID=" +
            item.secID +
            "&tID=" +
            this.currentUser.id,
          body: null,
          message: "subject removed successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.loadManageData();
      }
    },
    // ====== assign classes =======

    async LoadData() {
      this.dataLoading = true;
      var obj2 = {
        url:
          this.$store.state.domain +
          "Roles?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.allRoles = await this.get(obj2);
      // console.log(this.allRoles);

      this.dataLoading = false;
    },
    async LoadUsers() {
      this.userLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "Users/LoadUsers?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.allUsers = await this.get(obj);
      // console.log(this.allUsers);
      this.userLoading = false;
    },

    ensureRoleCoaDefaults() {
      if (!this.myObj || !Array.isArray(this.myObj)) return;
      this.myObj.forEach((group) => {
        (group.children || []).forEach((child) => {
          if (child.route === "accounts") {
            if (!Array.isArray(child.coaAccountIDs)) {
              child.coaAccountIDs = [0];
            }
          }
        });
      });
    },

    setRoleCoaAccounts(child) {
      child.coaAccountIDs = normalizeRoleCoaSelection(child.coaAccountIDs);
    },

    async loadCoaRoleOptions() {
      if (!this.roleCoaAccessEnabled) return;
      this.coaRoleOptionsLoading = true;
      try {
        const res = await this.get({
          url:
            this.$store.state.domain +
            "Accounts/LoadData?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          token: this.$store.state.userData.token,
        });
        let list = [];
        if (res && res.status === "success" && Array.isArray(res.data)) {
          list = res.data;
        } else if (Array.isArray(res)) {
          list = res;
        }
        this.coaRoleOptions = [
          { id: 0, title: this.$t("All Accounts") },
          ...list.map((row) => ({
            id: row.id,
            title: `${row.code ? row.code + " - " : ""}${row.title}`,
          })),
        ];
      } catch (e) {
        console.error("loadCoaRoleOptions", e);
        this.coaRoleOptions = [{ id: 0, title: this.$t("All Accounts") }];
      }
      this.coaRoleOptionsLoading = false;
    },

    ToggleAll(name) {
      // console.log(this.myObj);
      this.myObj.forEach((groups) => {
        groups.children.forEach((forms) => {
          if (name == "view") forms.view = this.all.view;
          else if (name == "add") forms.add = this.all.add;
          else if (name == "edit") forms.edit = this.all.edit;
          else if (name == "delete") forms.delete = this.all.delete;
        });
      });
    },
    async openModal() {
      this.all = {
        view: false,
        add: false,
        edit: false,
        delete: false,
      };
      this.request = true;
      var obj = {
        url:
          this.$store.state.domain +
          "Forms/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.myObj = await this.get(obj);
      this.ensureRoleCoaDefaults();
      await this.loadCoaRoleOptions();
      // console.log(this.myObj);

      // this.myObj.forEach((groups) => {
      //   groups.children.forEach((forms) => {
      //     let obj = this.permList.find((el) => el.title == forms.title);
      //     if (obj) {
      //       forms.permission = obj.data.map((el) => ({
      //         text: el.text,
      //         value: el.value,
      //       }));
      //       // console.log(forms);
      //     }
      //   });
      // });

      this.roleObj = {
        id: 0,
        name: "",
        forms: "",
        campusID: this.$store.state.userData.cId,
      };
      this.$bvModal.show("modal-roles");
      this.request = false;
    },
    async openEdit(role) {
      this.checkId = role.id;
      this.editLoading = true;
      this.all = {
        view: false,
        add: false,
        edit: false,
        delete: false,
      };
      var obj = {
        url:
          this.$store.state.domain +
          "Forms/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      let temp = await this.get(obj);
      this.roleObj = role;
      // this.myObj = JSON.parse(this.roleObj.forms);
      let currentFields = JSON.parse(this.roleObj.forms);
      // console.log(currentFields);

      temp.forEach((el) => {
        currentFields.forEach((curr) => {
          // comparing menu name
          if (el.name == curr.name) {
            el.children.forEach((el_ch) => {
              curr.children.forEach((curr_ch) => {
                // comparing submenu names
                if (el_ch.title == curr_ch.title) {
                  el_ch.view = curr_ch.view;
                  el_ch.add = curr_ch.add;
                  el_ch.edit = curr_ch.edit;
                  el_ch.delete = curr_ch.delete;
                  el_ch.hideFee = curr_ch.hideFee;
                  el_ch.editCampus = curr_ch.editCampus;
                  el_ch.interviewInfo = curr_ch.interviewInfo;
                  el_ch.approve = curr_ch.approve;
                  el_ch.review = curr_ch.review;
                  el_ch.disableDate = curr_ch.disableDate;
                  el_ch.receiveFee = curr_ch.receiveFee;
                  el_ch.disableReceiving = curr_ch.disableReceiving;
                  el_ch.editDate = curr_ch.editDate;
                  el_ch.disableImport = curr_ch.disableImport;
                  el_ch.disableExport = curr_ch.disableExport;
                  el_ch.assignSections = curr_ch.assignSections;
                  el_ch.optional = curr_ch.optional || curr_ch.optimal;
                  el_ch.reportTypes = curr_ch.reportTypes
                    ? curr_ch.reportTypes
                    : [];
                  el_ch.permission = curr_ch.permission;
                  el_ch.hidePayroll = curr_ch.hidePayroll;
                  el_ch.bulkIncrement = !!curr_ch.bulkIncrement;
                  el_ch.hideDocuments = curr_ch.hideDocuments;
                  el_ch.singlePage = curr_ch.singlePage;
                  el_ch.editAllows = curr_ch.editAllows
                    ? curr_ch.editAllows
                    : [];
                  el_ch.notificationTypes = curr_ch.notificationTypes
                    ? curr_ch.notificationTypes
                    : [];
                  el_ch.coaAccountIDs = Array.isArray(curr_ch.coaAccountIDs)
                    ? curr_ch.coaAccountIDs
                    : [0];
                }
              });
            });
          }
        });
      });
      // console.log(temp);
      this.myObj = temp;
      this.ensureRoleCoaDefaults();
      await this.loadCoaRoleOptions();
      this.editLoading = false;
      this.$bvModal.show("modal-roles");
    },

    AddOpen() {
      this.userObj = {
        id: 0,
        username: "",
        password: "",
        userRole: 0,
        name: "",
        avatar: "",
        forms: "",
        meta_role: "",
        campusID: this.$store.state.userData.cId,
      };
      this.visibility = true;
      this.sidebarTitle = "Add User";
      this.sidebarButton = "Save";

      this.selectedRole = null;
      this.syncProfilePhotoState("");
      var elem = this.$refs["UName"];
      elem.state = undefined;
      var elem = this.$refs["nameUser"];
      elem.state = undefined;
      var elem = this.$refs["role"];
      elem.state = undefined;
      var elem = this.$refs["pass"];
      elem.state = undefined;
    },
    Edit(item) {
      this.userObj = { ...item };
      this.selectedRole = item.meta_role;
      this.syncProfilePhotoState(this.userObj.avatar);
      // console.log(this.userObj);
      this.visibility = true;
      this.sidebarTitle = "Update User";
      this.sidebarButton = "Update";

      var elem = this.$refs["UName"];
      elem.state = undefined;
      var elem = this.$refs["nameUser"];
      elem.state = undefined;
      var elem = this.$refs["role"];
      elem.state = undefined;
      var elem = this.$refs["pass"];
      elem.state = undefined;
    },
    setRoleData() {
      // console.log(this.selectedRole);
      this.userObj.userRole = this.selectedRole.id;
      // this.userObj.forms = this.selectedRole.forms;
      let parsedObj = JSON.parse(this.selectedRole.forms);
      let newObj = [];
      parsedObj.forEach((menu) => {
        let newChildren = [];
        menu.children.forEach((el) => {
          if (
            el.view ||
            el.add ||
            el.edit ||
            el.delete ||
            el.permission ||
            (el.reportTypes && el.reportTypes.length > 0) ||
            (el.notificationTypes && el.notificationTypes.length > 0)
          )
            newChildren.push(el);
        });
        if (newChildren.length > 0) {
          menu.children = newChildren;
          newObj.push(menu);
        }
      });
      // console.log(newObj);
      this.userObj.forms = JSON.stringify(newObj);
      // console.log(this.userObj);
    },
    async selectlogo() {
      const file = this.$refs.fileProfile.files[0];
      if (!file) return;

      if (this.plus && String(this.plus).startsWith("blob:")) {
        URL.revokeObjectURL(this.plus);
      }

      this.fileProfile = file;
      this.logoloading = true;
      const localPreview = URL.createObjectURL(file);
      this.plus = localPreview;

      try {
        const uploaded = await uploadToMySkool([file]);
        const path = getUploadPath(uploaded[0]);
        if (!path) throw new Error("Upload path missing");

        URL.revokeObjectURL(localPreview);
        this.plus = path;
        this.userObj.avatar = path;
        this.logoloading = "loaded";
      } catch (err) {
        URL.revokeObjectURL(localPreview);
        this.plus = "";
        this.userObj.avatar = "";
        this.logoloading = false;
        console.log(err);
      } finally {
        if (this.$refs.fileProfile) this.$refs.fileProfile.value = "";
      }
    },
    deleteLogo() {
      this.syncProfilePhotoState("");
      this.userObj.avatar = "";
    },
    syncProfilePhotoState(avatar) {
      if (this.plus && String(this.plus).startsWith("blob:")) {
        URL.revokeObjectURL(this.plus);
      }

      const value = avatar || "";
      this.plus = value;
      this.logoloading = value ? "loaded" : false;

      if (this.$refs.fileProfile) this.$refs.fileProfile.value = "";
    },
    onUserSidebarHidden() {
      this.syncProfilePhotoState("");
    },
    getAvatarPreviewUrl(url) {
      if (!url) return "";
      if (String(url).startsWith("blob:")) return url;
      return getMediaPreviewUrl(url, "Image");
    },
    onProfilePreviewError(event) {
      const url = this.plus;
      if (!url || String(url).startsWith("blob:")) return;
      handleDrivePreviewError(event, url, "image");
    },
    CheckName() {
      var elem = this.$refs["name"];
      if (this.roleObj.name == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckUName() {
      var elem = this.$refs["nameUser"];
      if (this.userObj.name == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckUserName() {
      var elem = this.$refs["UName"];
      if (this.userObj.username == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckPassword() {
      var elem = this.$refs["pass"];
      if (this.userObj.password == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckRole() {
      var elem = this.$refs["role"];
      if (this.userObj.userRole == 0 || this.userObj.forms == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async Add() {
      this.CheckUName();
      this.CheckUserName();
      this.CheckPassword();
      this.CheckRole();
      if (
        this.CheckUName() == false ||
        this.CheckUserName() == false ||
        this.CheckPassword() == false ||
        this.CheckRole() == false
      ) {
        return this.$bvToast.toast(this.$t("Please fill the form correctly."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        this.loading = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Users/Save?db=" +
            this.$store.state.userData.db +
            "&userID=" +
            this.$store.state.userData.userID,
          body: this.userObj,
          message: this.$t("User added successfully"),
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          this.LoadUsers();
          this.visibility = false;
        }
        this.loading = false;
      }
    },
    async Delete(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });
      if (result.isConfirmed) {
        var status = await this.put({
          url:
            this.$store.state.domain +
            "Users/RemoveUser?_db=" +
            this.$store.state.userData.db +
            "&id=" +
            id +
            "&userID=" +
            this.$store.state.userData.userID,
          message: this.$t("User removed successfully"),
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadUsers();
      }
    },
    async save() {
      // console.log(this.roleObj);
      this.CheckName();
      if (this.CheckName() == false) {
        return this.$bvToast.toast("Please enter the role.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        this.roleObj.forms = JSON.stringify(this.myObj);
        // console.log(this.roleObj.forms);
        if (this.roleObj.id == 0) {
          this.request = true;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "Roles?db=" +
              this.$store.state.userData.db +
              "&userID=" +
              this.$store.state.userData.userID,
            body: this.roleObj,
            message: this.$t("Role added successfully"),
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          if (status) {
            this.LoadData();
            this.$bvModal.hide("modal-roles");
          }
        } else {
          this.request = true;
          var newTabs = [];
          var newForms = [];
          var fData = JSON.parse(this.roleObj.forms);
          // console.log("#####fDATA", fData);
          fData.forEach((item) => {
            item.children.forEach((el) => {
              if (el.route != null) el.route = el.route.replace("\n", "");
              if (
                el.view ||
                el.add ||
                el.edit ||
                el.delete ||
                el.permission ||
                (el.reportTypes && el.reportTypes.length > 0) ||
                (el.notificationTypes && el.notificationTypes.length > 0)
              )
                newForms.push(el);
            });
            item.children = newForms;
            newForms = [];

            if (item.children.length > 0) newTabs.push(item);
          });

          this.roleObj.forms = JSON.stringify(newTabs);

          var status = await this.post({
            url:
              this.$store.state.domain +
              "Roles/EditRole?db=" +
              this.$store.state.userData.db +
              "&userID=" +
              this.$store.state.userData.userID,
            body: this.roleObj,
            message: this.$t("Role updated successfully"),
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          if (status) {
            this.LoadData();
            this.$bvModal.hide("modal-roles");
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.scrollContent {
  max-height: 50vh;
  overflow-y: scroll;
}
.user-profile-photo-group {
  margin-bottom: 0;

  ::v-deep > div:not(.invalid-feedback) {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
.user-photo-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 120px;
}
.user-photo-frame {
  position: relative;
  width: 120px;
  height: 120px;
  flex-shrink: 0;
}
.user-photo-img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  cursor: pointer;
  display: block;
}
.user-photo-delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.25rem 0.4rem;
}
.user-photo-upload-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.72);
  border-radius: 100px;
  z-index: 3;
}
.rcorners2 {
  border-radius: 100px;
  border: 4px solid var(--primary);
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
